// extracted by mini-css-extract-plugin
var _1 = "nXUir";
export { _1 as "label" }
